import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import NumberFlow from '@number-flow/react'

import { currencyFormatOptions } from '@/utils/currency'

import Header from '@/components/dashboard/Header/Header'
import Navigation from '@/components/dashboard/Navigation/Navigation'
import MotionDiv from '@/components/common/Motion/MotionDiv'

import { useDashboardStore } from '@/store/useDashboardStore'
import { useTourStore } from '@/store/useTourStore'

import dashboardAPI from '@/services/api/dashboard'

import ExpenseBar from '@/components/dashboard/ExpenseBar/ExpenseBar'
import TaxCalendar from '@/components/dashboard/TaxCalendar/TaxCalendar'

import MotionText from '@/components/common/Motion/MotionText'

import { usePageSetup } from '@/hooks/usePageSetup'

import DashboardTour from '@/tours/DashboardTour'

export const DashboardPage = () => {
  const { t } = useTranslation()

  usePageSetup(t('dashboard.pageTitle'), { scroll: true })

  const financialYear = useDashboardStore((state) => state.financialYear)
  const dashboard = useDashboardStore((state) => state.dashboard)
  const setDashboard = useDashboardStore((state) => state.setDashboard)

  const financials = dashboard || {
    net: 0,
    bruto: 0,
    expenses: 0,
    vat_items: [],
    categories: { incomes: {}, expenses: {} },
    months_breakdown: []
  }

  useEffect(() => {
    dashboardAPI.show({ year: financialYear })
      .then((dashboard) => setDashboard(dashboard))
  }, [])

  const total = financials.net
  const dashboardTourCompleted = useTourStore((state) => state.dashboardTourCompleted)

  useEffect(() => {
    if (!DashboardTour.isActive() && !dashboardTourCompleted) {
      DashboardTour.start()
    }
  }, [dashboardTourCompleted])

  return (
    <div className="h-full bg-white flex flex-col">
      <Header />
      <div className="flex-1 p-5 pt-2 pb-[10rem]">
        <MotionDiv className='tour-total-income'>
          <p className='text-zinc-700 text-sm'>{t('income.yourIncome')}</p>
          <NumberFlow
            format={{
              style: currencyFormatOptions.style,
              currency: currencyFormatOptions.currency,
              useGrouping: currencyFormatOptions.useGrouping
            }}
            className='text-[1.75rem] font-semibold text-zinc-900 mb-2'
            value={total}
          />
          <ExpenseBar
            current={financials.expenses}
            total={financials.net}
          />
        </MotionDiv>
        <div className='flex flex-row mt-8 mb-4 tour-vat-memo'>
          <div className='flex flex-col mb-2 flex-1'>
            <MotionText
              className="w-full font-semibold text-lg text-black flex items-center"
              as='h2'>
                {t('taxes.taxCalendar')}
            </MotionText>
            <MotionText
              delay={0.1}
              as='p'
              className="text-xs text-zinc-500 leading-tight line-clamp-2">
                {t('taxes.taxCalendarDescription')}
            </MotionText>
          </div>
        </div>
        <TaxCalendar
          vatItems={financials.vat_items}
          categories={financials.categories}
          monthsActive={dashboard?.months_active}
          monthsBreakdown={financials.months_breakdown}
        />
      </div>
      <Navigation />
    </div>
  )
}

export default DashboardPage